import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/vault/[vaultId]/PublicVaultContent.tsx");
